"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRatio = void 0;
function withRatio(ratios, baseSize = 30) {
    return (slider) => {
        function updateSizeCb({ update }) {
            slider.slides.forEach((slide, i) => {
                const ratio = ratios[i];
                const size = ratio * baseSize;
                const sizeText = `${Number(size)}rem`;
                slide.style.maxWidth = sizeText;
                slide.style.minWidth = sizeText;
                update();
            });
        }
        slider.on('created', updateSizeCb);
        slider.on('optionsChanged', updateSizeCb);
    };
}
exports.withRatio = withRatio;
